import React from "react";
import classnames from "classnames";
import Link from "@/components/Link";
import Image from "@/components/Image/image";
import styles from "./blog.module.scss";
import TextBlock from "@/components/TextBlock/text-block";
import { AssetStoryblok, RichtextStoryblok } from "@/types/component-types-sb";

interface Props {
  name: string;
  content: {
    article_image?: AssetStoryblok;
  };
  intro?: string | RichtextStoryblok;
  full_slug: string;
  featured?: boolean;
  published: string;
  className?: string;
  hideDate?: boolean;
  video_count?: number;
}

const BlogIndexItem = (props: Props) => {
  const {
    name,
    content: { article_image },
    intro,
    full_slug,
    featured,
    published,
    className,
    hideDate,
    video_count,
  } = props;
  const aspect = { m: "3/2", d: "3/2" } as const;

  const classes = classnames(
    styles.indexItem,
    featured ? styles.featured : "",
    className
  );

  return (
    <Link href={`/${full_slug}`} className={classes}>
      {article_image && (
        <Image
          alt={article_image.alt}
          aspectMobile={aspect.m}
          aspectDesktop={aspect.d}
          filename={article_image.filename}
          focus={article_image.focus}
          className={styles.indexItemImage}
        />
      )}
      <div className={styles.indexItemTitle}>
        {!hideDate ? (
          <p className={"ef-text-caption u-mb-0"}>{published}</p>
        ) : null}
        {featured ? (
          // Featured item is the blog index page heading: keep it a semantic
          // <h1> (matching the desktop IndexFeaturedItemCopy) while preserving
          // the h4 visual size — bare h4 and .ef-h4 render identically.
          <h1 className={"ef-h4 u-mt-xs u-mb-xs"}>{name}</h1>
        ) : (
          <div className={video_count ? styles.videoCountContainer : ""}>
            <h6 className={"u-mt-xs"}>{name}</h6>
            {video_count ? (
              <div className={`${styles.videoCount} u-mt-xs`}>
                {video_count} videos
              </div>
            ) : null}
          </div>
        )}
        {featured ? (
          <TextBlock
            max_lines={"4"}
            text_style={"paragraph-light-small"}
            content={
              typeof intro === "string"
                ? {
                    type: "paragraph",
                    text: intro,
                  }
                : intro
            }
            _uid=""
            component="text-block"
          />
        ) : null}
      </div>
    </Link>
  );
};

export default BlogIndexItem;
